import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('tipos.distributor.comer')
    },
    {
      id: 2,
      name: i18n.t('tipos.distributor.comer_soporte')
    },
  ]
}

export function TIPOS_DISTRIBUIDOR (state) {
  return configHelper.getConfig(state, 'TIPOS_DISTRIBUIDOR', GenerateConfig)
}
